import {
  CarInDriverOrder,
  DriverInDriverOrder,
} from '../../types/carAllocation';

export const generateDriverFormData = (): DriverInDriverOrder => {
  const carCategory = {
    id: null,
    name: '',
  };

  const car: CarInDriverOrder[] = [
    {
      carId: null,
      carCategory: carCategory,
      carNo: '',
      carAllocations: [],
      isAvailable: true,
    },
  ];

  return {
    userId: null,
    driverName: '',
    cars: car,
    workTimes: [],
  };
};

export const generateCarFormData = (): CarInDriverOrder => {
  const carCategory = {
    id: null,
    name: '',
  };

  return {
    carId: null,
    carCategory: carCategory,
    carNo: '',
    carAllocations: [],
    isAvailable: true,
  };
};
